/**
 * A component representing the footer of the Selects Sites Panel.
 */

import UploadDialog from './dialogs/upload-dialog';
import OptimiseDialog from './dialogs/optimise-dialog';
import ThinOutSitesDialog from "./dialogs/thin-out-sites-dialog";

import OptimiseWorker from 'worker-loader!../../utils/optimiser/optimise-worker.js';

const DOWNLOAD_LIST_BUTTON_NAME = 'aims_msp_list_download_button';
const DOWNLOAD_CSV_BUTTON_NAME = 'aims_msp_download_csv_button';
const UPLOAD_BUTTON_NAME = 'aims_msp_upload_button';
const OPTIMISE_BUTTON_NAME = 'aims_msp_optimise_button';
const THIN_OUT_SITES_BUTTON_NAME = 'aims_msp_thin_out_sites_button';
const TEMPLATE = `
    <button type="button" class="btn btn-primary btn-sm ${DOWNLOAD_LIST_BUTTON_NAME}">
        <i class="material-icons">file_download</i> IDs
    </button>
    <button type="button" class="btn btn-primary btn-sm ${DOWNLOAD_CSV_BUTTON_NAME}">
        <i class="material-icons">file_download</i> CSV
    </button>
    <button type="button" class="btn btn-primary btn-sm ${UPLOAD_BUTTON_NAME}">
        <i class="material-icons">file_upload</i>
    </button>
    <button type="button" class="btn btn-primary btn-sm ${OPTIMISE_BUTTON_NAME}">
       Select optimised sites
    </button>
    <button type="button" class="btn btn-primary btn-sm ${THIN_OUT_SITES_BUTTON_NAME}">
       Thin out selected sites
    </button>
`;

export default class SelectedSitesPanelFooterComponent {

  constructor($parent, datasetsModel, selectedSitesModel, referenceSitesHashModel, algorithmsModel,
              variablesModel, siteDistanceModel, onClickDownloadListHandler, onClickDownloadCsvHandler) {

    // Cache references.
    this._$parent = $parent;
    this._datasetsModel = datasetsModel;
    this._selectedSitesModel = selectedSitesModel;
    this._referenceSitesHashModel = referenceSitesHashModel;
    this._algorithmsModel = algorithmsModel;
    this._variablesModel = variablesModel;
    this._siteDistanceModel = siteDistanceModel;
    this._onClickDownloadListHandler = onClickDownloadListHandler;
    this._onClickDownloadCsvHandler = onClickDownloadCsvHandler;

    this._optimiseWorker = new OptimiseWorker();
    this._optimiseWorker.postMessage({
      'cmd': 'setActiveDataset',
      'msg': {
        'activeDataset': this._datasetsModel.getActiveDataset()
      }
    });

    this._referenceSitesHashModel.on(this._referenceSitesHashModel.EVENT_DATA_CHANGED, () => {
      this._optimiseWorker.postMessage({
        'cmd': 'setReferenceSitesHashModel',
        'msg': {
          'referenceSitesHash': this._referenceSitesHashModel.getData()
        }
      });
    });
    this._siteDistanceModel.on(this._siteDistanceModel.EVENT_DATA_CHANGED, () => {
      this._optimiseWorker.postMessage({
        'cmd': 'setSiteDistanceData',
        'msg': {
          'siteDistanceData': this._siteDistanceModel.getData()
        }
      });
    });

    // Insert the template to render the list.
    this._$parent.html(TEMPLATE);

    // Add handlers for the buttons.
    this._$parent.find(`.${DOWNLOAD_LIST_BUTTON_NAME}`).click(this._handleDownloadListButtonClick.bind(this));
    this._$parent.find(`.${DOWNLOAD_CSV_BUTTON_NAME}`).click(this._handleDownloadCsvButtonClick.bind(this));
    this._$parent.find(`.${UPLOAD_BUTTON_NAME}`).click(this._handleUploadButtonClick.bind(this));
    this._$parent.find(`.${OPTIMISE_BUTTON_NAME}`).click(this._handleOptimiseButtonClick.bind(this));
    this._$parent.find(`.${THIN_OUT_SITES_BUTTON_NAME}`).click(this._handleThinOutSitesButtonClick.bind(this));
  }

  /**
   * Event handler invoked when the user clicks the download csv button.
   */
  _handleDownloadCsvButtonClick() {
    this._onClickDownloadCsvHandler.call();
  }

  /**
   * Event handler invoked when the user clicks the download list button.
   */
  _handleDownloadListButtonClick() {
    this._onClickDownloadListHandler.call();
  }

  /**
   * Event handler invoked when the user clicks the upload button.
   */
  _handleUploadButtonClick() {
    new UploadDialog(this._selectedSitesModel, this._referenceSitesHashModel);
  }

  /**
   * Event handler invoked when the user clicks the optimise button.
   */
  _handleOptimiseButtonClick() {
    new OptimiseDialog(
      this._selectedSitesModel,
      this._referenceSitesHashModel,
      this._datasetsModel.getActiveDataset(),
      this._algorithmsModel,
      this._variablesModel,
      this._optimiseWorker
    );
  }

  /**
   * Event handler invoked when the user clicks the thin-out-sites button.
   */
  _handleThinOutSitesButtonClick() {
    new ThinOutSitesDialog(
      this._datasetsModel,
      this._selectedSitesModel,
      this._referenceSitesHashModel,
      this._algorithmsModel,
      this._variablesModel,
      this._siteDistanceModel
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/selected-sites-panel/component-footer.js